<template>
  <div class="wrap">
    <el-scrollbar>
      <depts ref="deptTree" @nodeClick="onDeptTreeNodeClick" />
    </el-scrollbar>
    <staffs ref="staffTable" />
  </div>
</template>

<script>
export default {
  components: {
    depts: () => import('./dept/list.vue'),
    staffs: () => import('./staff/list.vue')
  },
  methods: {
    onDeptTreeNodeClick (data) {
      this.$refs.staffTable.queryParams.deptId = data.Id
      this.$refs.staffTable.onSearch()
    }
  }
};
</script>


<style lang="scss" scoped>
.wrap {
  display: grid;
  grid-template-columns: 300px 1fr;
  height: 100%;
  grid-gap: 16px;
  :deep(.el-tree) {
    padding: 16px;
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.show-hide:hover :nth-child(2) {
  display: inline-block !important;
}
</style>